import {createEntitySlice} from '../../../utils/createEntitySlice';
import {DocumentTemplateSolution} from '../../../types/documentTemplateSolution';
import {DocumentTemplateSolutionThunks} from './documentTemplateSolutionThunks';

export interface DocumentTemplateSolutionState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  documentTemplateSolutions?: any;
  documentTemplateSolution?: any;
  pagy?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: DocumentTemplateSolutionState = {
  status: 'idle',
  error: null,
  documentTemplateSolutions: [],
  documentTemplateSolution: {},
  pagy: {},
  isEditing: false,
  activeTab: 'All',
};

const documentTemplateSolutionSlice = createEntitySlice<DocumentTemplateSolution>({
  name: 'documentTemplateSolution',
  initialState,
  thunks: DocumentTemplateSolutionThunks,
  entityKey: 'documentTemplateSolution',
  entitiesKey: 'documentTemplateSolutions',
  reducers: {},
});

export const {
  setEntity: setDocumentTemplateSolution,
  setIsEditing,
  setActiveTab,
} = documentTemplateSolutionSlice.actions;
export {initialState as documentTemplateSolutionInitialState};
export default documentTemplateSolutionSlice.reducer;
